import { ReactComponent as DiscordIcon } from "./discord.svg";
import { ReactComponent as InstagramIcon } from "./instagram.svg";
import { ReactComponent as TelegramIcon } from "./telegram.svg";
import { ReactComponent as ThreadsIcon } from "./threads.svg";

import styles from "./index.module.scss";

const SocialMedia = () => {
  const goTo = (type: "discord" | "instagram" | "telegram" | "threads") => {
    switch (type) {
      case "discord":
        window.open("https://discord.com/invite/swP2hujq", "_blank");
        break;
      case "instagram":
        window.open("https://www.instagram.com/sensechat_hk", "_blank");
        break;
      case "telegram":
        window.open("https://t.me/sensechathk", "_blank");
        break;
      case "threads":
        window.open("https://www.threads.net/@sensechat_hk", "_blank");
        break;
    }
  };
  return (
    <div className={styles.container}>
      <span>關注我們：</span>
      <DiscordIcon
        data-ti="media_discord_click"
        data-tn="社媒入口discord点击"
        className={styles.icon}
        onClick={() => goTo("discord")}
      />
      <InstagramIcon
        data-ti="media_instagram_click"
        data-tn="社媒入口instagram点击"
        className={styles.icon}
        onClick={() => goTo("instagram")}
      />
      <TelegramIcon
        data-ti="media_telegram_click"
        data-tn="社媒入口telegram点击"
        className={styles.icon}
        onClick={() => goTo("telegram")}
      />
      <ThreadsIcon
        data-ti="media_threads_click"
        data-tn="社媒入口threads点击"
        className={styles.icon}
        onClick={() => goTo("threads")}
      />
    </div>
  );
};

export default SocialMedia;
